import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { AiFillCloseCircle } from "react-icons/ai";
import axios from "axios";
import toast from "react-hot-toast";
import uploadImg from "./ReuseableImgUploadFuctions/uploadImg";
import { State, City } from "country-state-city";
import Select from "react-select";

function EditStaffForm({ setEditstaff, currentItem }) {
  const [currentStaff, setCurrentStaff] = useState(currentItem);
  const [ProfilePic, setProfilePic] = useState(currentItem.profilePic);
  const [adhaarFront, setAdhaarFront] = useState(currentItem.adhaarFrontPic);
  const [adhaarBack, setAdhaarBack] = useState(currentItem.adhaarBackPic);
  const [checkImg, setCheckImg] = useState(false);
  const [load, setLoad] = useState(false);
  const [allStates, setAllStates] = useState([]);
  const [allCities, setAllCities] = useState([]);
  const [selectedState, setSelectedState] = useState();
  const [selectedCity, setSelectedCity] = useState();
  console.log(currentStaff);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    setValue,
  } = useForm({
    defaultValues: {
      ...currentItem,
      joiningDate: new Date(currentItem.joiningDate).toISOString().slice(0, 10),
      dateOfBirth: new Date(currentItem.dateOfBirth).toISOString().slice(0, 10),
      state: currentItem?.state || "",
      city: currentItem?.city || "",
    },
  });

  //Fetching all states of India
  useEffect(() => {
    const states = State.getStatesOfCountry("IN"); //IN is the country code for India
    console.log("States: ", states);
    const formattedStates = states.map((state) => ({
      value: state?.isoCode,
      label: state?.name,
    }));

    setAllStates(formattedStates);
  }, []);

  //Setting existing state to the selectedState initially
  useEffect(() => {
    if (allStates.length > 0 && currentItem?.state) {
      const selectedState = allStates.find(
        (state) => state.label === currentItem?.state
      );
      setSelectedState(selectedState || null);
    }
  }, [allStates, currentItem]);

  console.log("State: ", selectedState);

  //Fetch cities when state is selected
  useEffect(() => {
    if (selectedState) {
      console.log("Selected State: ", selectedState);
      const cities = City.getCitiesOfState("IN", selectedState?.value);
      const formattedCities = cities.map((city) => ({
        value: city?.name,
        label: city?.name,
      }));
      setAllCities(formattedCities);
    } else {
      setAllCities([]);
    }
  }, [selectedState]);

  const uploadHandle = async (file, type) => {
    console.log(file, type);
    setCheckImg(true);
    toast("Uploading, Please wait...", {
      icon: "👏",
      style: {
        borderRadius: "10px",
        background: "#333",
        color: "#fff",
      },
      duration: 4000,
    });

    const imgUrl = await uploadImg(file[0]);

    if (type == "adhaarFront") {
      setAdhaarFront(imgUrl);
    } else if (type == "profile") {
      setProfilePic(imgUrl);
    } else {
      setAdhaarBack(imgUrl);
    }

    setCheckImg(false);
  };

  const onSubmit = async (data) => {
    setLoad(true);
    try {
      // Create final form data object with image URLs
      const finalData = {
        ...data,
        profilePic: ProfilePic || currentItem.profilePic,
        adhaarFrontPic: adhaarFront || currentItem.adhaarFrontPic,
        adhaarBackPic: adhaarBack || currentItem.adhaarBackPic,
      };

      let config = {
        method: "patch",
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_URL}/users/user-edit-profile/${currentItem._id}`,
        headers: {
          "Content-Type": "application/json",
        },
        data: finalData,
      };

      axios
        .request(config)
        .then((response) => {
          console.log(response.data);
          toast.success("Staff Updated.");
          setEditstaff(false);
          setLoad(false);
        })
        .catch((error) => {
          console.log(error);
          toast.error(error.response.data.message);
          setLoad(false);
        });

      console.log("Final Data to Submit:", finalData);
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Error submitting form, please try again.");
    }
  };

  return (
    <div className="flex fixed inset-0 z-50 items-center justify-center min-h-screen bg-[#0000008f] p-4">
      <div className="bg-white h-[30rem] md:h-[35rem] overflow-auto relative rounded-lg shadow-lg p-8 lg:py-8 lg:px-16 w-full max-w-5xl">
        <div className="mb-6">
          <h2 className="text-2xl font-semibold text-center">Edit Staff</h2>
          <AiFillCloseCircle
            onClick={() => setEditstaff(false)}
            className="cursor-pointer text-primaryColor absolute top-4 right-4"
            size={30}
          />
        </div>

        <form className="" onSubmit={handleSubmit(onSubmit)}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="flex flex-col">
              <label className="text-sm font-medium mb-1">
                Name <span className="text-red-500">*</span>
              </label>
              <input
                {...register("name", { required: "Name is required" })}
                type="text"
                className={`border rounded-md p-2 focus:outline-none focus:ring ${
                  errors.name ? "border-red-500" : "focus:border-blue-300"
                }`}
                placeholder="Enter name"
              />
              {errors.name && (
                <p className="text-red-500 text-xs">{errors.name.message}</p>
              )}
            </div>

            <div className="flex flex-col">
              <label className="text-sm font-medium mb-1">
                Mob Number <span className="text-red-500">*</span>
              </label>
              <input
                {...register("phoneNumber", {
                  required: "phoneNumber number is required",
                  pattern: {
                    value: /^[0-9]{10}$/,
                    message: "Enter a valid 10-digit phoneNumber number",
                  },
                })}
                type="text"
                onInput={(e) => {
                  e.target.value = e.target.value
                    .replace(/[^0-9]/g, "")
                    .slice(0, 10);
                }}
                className={`border rounded-md p-2 focus:outline-none focus:ring ${
                  errors.phoneNumber
                    ? "border-red-500"
                    : "focus:border-blue-300"
                }`}
                placeholder="Enter phoneNumber number"
              />
              {errors.phoneNumber && (
                <p className="text-red-500 text-xs">
                  {errors.phoneNumber.message}
                </p>
              )}
            </div>

            <div className="flex flex-col">
              <label className="text-sm font-medium mb-1">
                Email ID <span className="text-red-500">*</span>
              </label>
              <input
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: "Enter a valid email",
                  },
                })}
                type="email"
                className={`border rounded-md p-2 focus:outline-none focus:ring ${
                  errors.email ? "border-red-500" : "focus:border-blue-300"
                }`}
                placeholder="Enter email"
              />
              {errors.email && (
                <p className="text-red-500 text-xs">{errors.email.message}</p>
              )}
            </div>

            <div className="flex flex-col">
              <label className="text-sm font-medium mb-1">
                UserType <span className="text-red-500">*</span>
              </label>
              <select
                {...register("userType", { required: "UserType is required" })}
                className={`border rounded-md p-2 focus:outline-none focus:ring ${
                  errors.userType ? "border-red-500" : "focus:border-blue-300"
                }`}
              >
                <option value="">Select UserType</option>
                <option value="subAdmin">SubAdmin</option>
                <option value="manager">Manager</option>
              </select>
              {errors.userType && (
                <p className="text-red-500 text-xs">
                  {errors.userType.message}
                </p>
              )}
            </div>
            <div className="flex flex-col">
              <label className="text-sm font-medium mb-1">
                Adhaar Number <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                onInput={(e) => {
                  e.target.value = e.target.value
                    .replace(/[^0-9]/g, "")
                    .slice(0, 12); // Replace non-numeric characters
                }}
                {...register("adhaarNumber", {
                  required: "UserType is required",
                })}
                className={`border rounded-md p-2 focus:outline-none focus:ring ${
                  errors.adhaarNumber
                    ? "border-red-500"
                    : "focus:border-blue-300"
                }`}
                placeholder="Enter your Adhaar Number"
              />

              {errors.adhaarNumber && (
                <p className="text-red-500 text-xs">
                  {errors.adhaarNumber.message}
                </p>
              )}
            </div>
            <div className="flex flex-col">
              <label className="text-sm font-medium mb-1">
                Joining Date <span className="text-red-500">*</span>
              </label>
              <input
                {...register("joiningDate", {
                  required: "Date of birth is required",
                })}
                type="date"
                className={`border rounded-md p-2 focus:outline-none focus:ring ${
                  errors.joiningDate
                    ? "border-red-500"
                    : "focus:border-blue-300"
                }`}
              />
              {errors.joiningDate && (
                <p className="text-red-500 text-xs">
                  {errors.joiningDate.message}
                </p>
              )}
            </div>

            <div className="flex flex-col">
              <label className="text-sm font-medium mb-1">
                Password <span className="text-red-500">*</span>
              </label>
              <input
                {...register("password", { required: "Password is required" })}
                type="password"
                className={`border rounded-md p-2 focus:outline-none focus:ring ${
                  errors.password ? "border-red-500" : "focus:border-blue-300"
                }`}
                placeholder="Enter password"
              />
              {errors.password && (
                <p className="text-red-500 text-xs">
                  {errors.password.message}
                </p>
              )}
            </div>

            <div className="flex flex-col">
              <label className="text-sm font-medium mb-1">
                Date of Birth <span className="text-red-500">*</span>
              </label>
              <input
                {...register("dateOfBirth", {
                  required: "Date of birth is required",
                })}
                type="date"
                className={`border rounded-md p-2 focus:outline-none focus:ring ${
                  errors.dateOfBirth
                    ? "border-red-500"
                    : "focus:border-blue-300"
                }`}
              />
              {errors.dateOfBirth && (
                <p className="text-red-500 text-xs">
                  {errors.dateOfBirth.message}
                </p>
              )}
            </div>

            <div className="flex flex-col">
              <label className="text-sm font-medium mb-1">Gender</label>
              <select
                {...register("gender", { required: "Gender is required" })}
                className={`border rounded-md p-2 focus:outline-none focus:ring ${
                  errors.gender ? "border-red-500" : "focus:border-blue-300"
                }`}
              >
                <option value="">Select Gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
              </select>
              {errors.gender && (
                <p className="text-red-500 text-xs">{errors.gender.message}</p>
              )}
            </div>

            <div className="flex flex-col">
              <label className="text-sm font-medium mb-1">
                Address <span className="text-red-500">*</span>
              </label>
              <input
                {...register("address", { required: "Address is required" })}
                className={`border rounded-md p-2 focus:outline-none focus:ring ${
                  errors.address ? "border-red-500" : "focus:border-blue-300"
                }`}
                placeholder="Enter address"
              />
              {errors.address && (
                <p className="text-red-500 text-xs">{errors.address.message}</p>
              )}
            </div>

            {/* State */}
            <div>
              <label
                htmlFor="state"
                className="text-sm font-medium text-primaryTextColor"
              >
                State *
              </label>

              <Select
                options={allStates}
                value={
                  allStates.find((state) => state.label === watch("state")) ||
                  null
                } // Pre-select state in edit mode
                onChange={(option) => {
                  console.log("option", option);
                  setSelectedState(option);
                  setValue("state", option.label, { shouldValidate: true }); // Ensure validation triggers
                }}
                required
                placeholder="Select State"
                className={`border ${
                  errors.state ? "border-red-500" : "border-gray-300"
                } rounded w-full`}
              />
              {errors.state && (
                <span className="text-red-500 text-sm">
                  {errors.state.message}
                </span>
              )}
            </div>

            {/* City */}
            <div>
              <label
                htmlFor="city"
                className="text-sm font-medium text-primaryTextColor"
              >
                City *
              </label>

              <Select
                options={allCities}
                value={
                  allCities.find((city) => city.label === watch("city")) || null
                } // Pre-select state in edit mode
                onChange={(option) => {
                  console.log("option", option);
                  setValue("city", option.label, { shouldValidate: true }); // Ensure validation triggers
                }}
                required
                placeholder="Select City"
                className={`border ${
                  errors.city ? "border-red-500" : "border-gray-300"
                } rounded w-full`}
              />
              {errors.city && (
                <span className="text-red-500 text-sm">
                  {errors.city.message}
                </span>
              )}
            </div>

            <div className="flex flex-col">
              <label className="text-sm font-medium mb-1">
                Nationality <span className="text-red-500">*</span>
              </label>
              <input
                {...register("nationality", {
                  required: "Nationality is required",
                })}
                type="text"
                className={`border rounded-md p-2 focus:outline-none focus:ring ${
                  errors.nationality
                    ? "border-red-500"
                    : "focus:border-blue-300"
                }`}
                placeholder="Enter nationality"
              />
              {errors.nationality && (
                <p className="text-red-500 text-xs">
                  {errors.nationality.message}
                </p>
              )}
            </div>

            <div className="flex flex-col">
              <label className="text-sm font-medium mb-1">
                Profile Pic <span className="text-red-500">*</span>
              </label>
              <input
                {...register("profilePic")}
                type="file"
                onChange={(e) => {
                  uploadHandle(e.target.files, "profile");
                }}
                className={`border rounded-md p-2 focus:outline-none focus:ring ${
                  errors.profilePic ? "border-red-500" : "focus:border-blue-300"
                }`}
              />
              {errors.profilePic && (
                <p className="text-red-500 text-xs">
                  {errors.profilePic.message}
                </p>
              )}

              <img
                src={ProfilePic}
                alt="No Image"
                srcset=""
                className="w-[6rem] rounded-md object-cover mt-2"
              />
            </div>

            <div className="flex flex-col">
              <label className="text-sm font-medium mb-1">
                Aadhaar Card Front Img <span className="text-red-500">*</span>
              </label>
              <input
                {...register("adhaarFrontPic")}
                type="file"
                onChange={(e) => {
                  uploadHandle(e.target.files, "adhaarFront");
                }}
                className={`border rounded-md p-2 focus:outline-none focus:ring ${
                  errors.adhaarFrontPic
                    ? "border-red-500"
                    : "focus:border-blue-300"
                }`}
              />
              {errors.adhaarFrontPic && (
                <p className="text-red-500 text-xs">
                  {errors.adhaarFrontPic.message}
                </p>
              )}

              <img
                src={adhaarFront}
                alt="No Image"
                srcset=""
                className="w-[6rem] rounded-md object-cover mt-2"
              />
            </div>

            <div className="flex flex-col">
              <label className="text-sm font-medium mb-1">
                Aadhaar Card Back Img <span className="text-red-500">*</span>
              </label>
              <input
                {...register("adhaarBackPic")}
                type="file"
                onChange={(e) => {
                  uploadHandle(e.target.files, "adhaarBack");
                }}
                className={`border rounded-md p-2 focus:outline-none focus:ring ${
                  errors.adhaarBackPic
                    ? "border-red-500"
                    : "focus:border-blue-300"
                }`}
              />
              {errors.adhaarBackPic && (
                <p className="text-red-500 text-xs">
                  {errors.adhaarBackPic.message}
                </p>
              )}
              <img
                src={adhaarBack}
                alt="No Image"
                srcset=""
                className="w-[6rem] rounded-md object-cover mt-2"
              />
            </div>
          </div>

          <div className="flex justify-between mt-6 gap-6">
            <button
              onClick={() => setEditstaff(false)}
              className="bg-white w-[50%] border hover:bg-secondaryTextColor px-4 py-2 rounded-md"
            >
              Cancel
            </button>
            <button
              disabled={checkImg ? true : false}
              className={`tracking-wide w-[50%]  ${
                checkImg ? "cursor-not-allowed" : "cursor-pointer"
              } bg-primaryBtnColor text-white py-2 px-4 rounded-lg hover:bg-primaryBtnHoverColor`}
            >
              {"Save"}
            </button>
          </div>
        </form>
      </div>

      {load && (
        <div className="fixed inset-0 h-screen w-screen flex items-center justify-center bg-black bg-opacity-50">
          <span class="loader"></span>
        </div>
      )}
    </div>
  );
}

export default EditStaffForm;
